/** Registers the service worker that makes Couch installable (doc 27). Failing to is not an error worth more than a log line. */
export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch((error: unknown) => {
      console.warn('[couch] service worker not registered', error);
    });
  });
}

/** True when Couch runs as an installed app (home screen), not in a browser tab. */
export function isInstalledApp(): boolean {
  const iosStandalone = (navigator as Navigator & { standalone?: boolean }).standalone === true;
  return iosStandalone || window.matchMedia('(display-mode: standalone)').matches;
}

interface InstallPromptEvent extends Event { prompt: () => Promise<void> }

let installPrompt: InstallPromptEvent | undefined;
const waiting = new Set<() => void>();

/** Chrome/Android announce installability once, early; keep the event for the Install button. */
export function captureInstallPrompt(): void {
  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    installPrompt = event as InstallPromptEvent;
    for (const notify of waiting) notify();
  });
}

export function canPromptInstall(): boolean {
  return installPrompt !== undefined;
}

export function onInstallPromptChange(notify: () => void): () => void {
  waiting.add(notify);
  return () => { waiting.delete(notify); };
}

export async function promptInstall(): Promise<void> {
  const event = installPrompt;
  installPrompt = undefined;
  await event?.prompt();
  for (const notify of waiting) notify();
}
